import { NewsWidget } from '@/core/widgets/export';

/** Applies mobile-only metadata (e.g. the equivalent deep-dive app id) to a dashboard widget instance in place. */
export function withMobileMeta<W extends NewsWidget>(
  widget: W,
  meta: { deepDiveId?: string; mobileCategory?: string },
): W {
  return Object.assign(widget, meta);
}
